module.exports = function () {
    function productTabs() {
        $(".content-tabs").hide();

        $(".woocommerce-tabs.wc-tabs-wrapper div:first-of-type ").show();

        $(".title-tabs").on("click", function (event) {
            event.preventDefault();
            $('.activeTitle').removeClass("activeTitle");
            if ($(this).next('.content-tabs').hasClass('active')) {
                $('.active').removeClass("active").slideToggle();
            }
            else {
                $('.active').removeClass("active").slideToggle();
                $(this).next().addClass("active").slideToggle();
                $(this).addClass("activeTitle");
            }
        });
    }


    window.addEventListener('load ready resize', productTabs);
    productTabs();

    $('.sku_wrapper').hide();
    $('.stars:last').remove();
};
